module.exports = __webpack_public_path__ + "img/adaptive-logo.df1b8d6f.png";